import React, { useEffect, useState } from 'react';
import { Alert, List, Spin, Typography } from 'antd';
import { Link } from 'react-router-dom';
import GcPagina from '../components/Layout/GcPagina';
import CatalogoInformes from '../components/Reportes/CatalogoInformes';
import { usePermissions } from '../contexts/PermissionContext';
import { listarInformes, mensajeDeError, RECURSO_REPORTES_GESTIONAR, type InformeListado } from '../api/reportesApi';

/**
 * El listado de Reportes (#393), en `/reportes`, dentro del marco de Gescom.aux: los informes activos que el usuario puede
 * abrir, ya filtrados por la API con la misma regla que el visor, y ordenados por título. Cada uno se abre en una pestaña
 * nueva, en el visor a pantalla completa (#386).
 */
const ListadoInformes: React.FC = () => {
  const [informes, setInformes] = useState<InformeListado[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let vivo = true;
    listarInformes()
      .then((leidos) => { if (vivo) setInformes(leidos); })
      .catch((e) => { if (vivo) setError(mensajeDeError(e, 'No se ha podido cargar el listado de informes. Inténtalo de nuevo en unos minutos.')); });
    return () => { vivo = false; };
  }, []);

  return (
    <GcPagina seccion="Reportes" titulo="Reportes">
      {error && <Alert type="error" showIcon message={error} />}
      {!error && !informes && <Spin tip="Cargando los informes…"><div style={{ minHeight: 120 }} /></Spin>}
      {informes && (
        <List
          bordered
          dataSource={informes}
          locale={{ emptyText: 'No tienes ningún informe disponible.' }}
          renderItem={(informe) => (
            <List.Item>
              <List.Item.Meta
                title={(
                  <Link to={`/reportes/${encodeURIComponent(informe.nombre)}`} target="_blank" rel="noopener noreferrer">
                    {informe.titulo}
                  </Link>
                )}
                description={informe.responsable ? <Typography.Text type="secondary">Responsable: {informe.responsable}</Typography.Text> : null}
              />
            </List.Item>
          )}
        />
      )}
    </GcPagina>
  );
};

/** `/reportes`: con `Reportes.Gestionar`, la gestión del catálogo (#411); sin él, el listado de siempre. */
const ReportesListadoPage: React.FC = () => {
  const { hasPermission } = usePermissions();
  return hasPermission(RECURSO_REPORTES_GESTIONAR) ? <CatalogoInformes /> : <ListadoInformes />;
};

export default ReportesListadoPage;
